import { SkillOperateType } from "gamedata/GameData";
import { gameName } from "./common";
import { GameVer, lstring, Realm, tt } from "./Lang";

export function mergeSkillType(operateType: SkillOperateType) {
  switch (operateType) {
    case "A1":
    case "A2":
    case "A3":
      return "A";

    default:
      return "P";
  }
}

export function getGenSkillsGameVer(gver: GameVer) {
  switch (gver) {
    case "c1":
    case "c2":
    case "c3":
    case "c4":
      return "OLD";

    default:
      return "NEW";
  }
}

export function getDescription(props: {
  realm: Realm;
  skill: {
    name: lstring;
    desc: lstring;
  };
}) {
  const { realm, skill } = props;
  const t = tt.bind(null, realm.lang);
  const game = gameName(realm.game);
  return t({
    en: `Skill ${skill.name.en}. ${skill.desc.en} ${game}`.trim(),
    ru: `Умение ${skill.name.ru} (${skill.name.en}). ${skill.desc.ru} ${game}`.trim(),
  });
}
